import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import font from "src/styles/font";
import device from "src/styles/device";
import { UseUpload } from "src/context/UploadProductContext";
import { convertPrice } from "src/common";

import {
  Box,
  TextField,
  Autocomplete,
  createFilterOptions,
  InputAdornment,
  Stack,
  IconButton,
} from "@mui/material";

import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import EditIcon from "@mui/icons-material/Edit";

const Content = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 0 24px;
  border-bottom: 10px solid var(--darkwhite-color);
`;

const WrapperHeader = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto 24px;
  text-align: center;
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const TextOption = styled(Box)`
  width: 100%;
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;
`;

const ProductDetail = styled.div`
  width: 100%;
  /* padding: 16px 24px; */
  margin-bottom: 18px;
  display: flex;
`;

const WrapperProduct = styled.div`
  width: calc(100% - 112px);
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
`;

const TextItem = styled(Box)`
  width: ${({ width }) => (width ? width : "100%")};
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;

  :last-child {
    margin-bottom: 0;
  }
`;

const TextLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: var(--secondary-color);

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 30%;
      flex: 0 0 30%;

      @media ${device.mobileL} {
        width: 28%;
        flex: 0 0 28%;
      }
    `}

  ${({ totalPrice }) =>
    totalPrice &&
    css`
      font-weight: 600;
      text-align: center;
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}
`;

const TextUnit = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: var(--darkgrey-color);
  text-align: right;
  width: 30%;
  flex: 0 0 30%;

  @media ${device.mobileL} {
    width: 22%;
    flex: 0 0 22%;
  }
`;

const WrapperTextfield = styled.div`
  /* width: 100%;
  margin: 24px 0; */

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    padding: 16px;
    text-align: center;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  /* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0
  } */
`;

const DetailSection = styled.div`
  width: 100%;
  max-width: 578px;
  margin: 0 auto;
  padding: 24px;
`;

const DetailGroup = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  :last-child {
    margin-bottom: 0;
  }
`;

const NumberGroup = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  flex: 0 0 40%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
  .MuiOutlinedInput-input {
    padding: 8px 16px;
    text-align: center;
  }

  @media ${device.mobileL} {
    width: 50%;
    flex: 0 0 50%;
  }
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const EditProduct = ({
  productData,
  dataProductList,
  onSubmit,
  onRemoveElement,
  onClose,
  isRemoveDisabled,
}) => {
  const [isEditProduct, setIsEditProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    product_choice_id: null,
    service_type: null,
    other_code: "",
    other_text: "",
    other_unit: "",
    volume: 0,
    price: 0,
    discount: 0,
    total: 0,
    description: "",
  });

  const { masterdata } = UseUpload();

  const color_data = masterdata.color_data;

  const submitEdit = async () => {
    await onSubmit(selectedProduct);
    await onClose();
  };

  useEffect(() => {
    setSelectedProduct(productData);
  }, [productData]);

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  return (
    <>
      <Content>
        <Header>
          {isEditProduct ? (
            <WrapperHeader>
              <WrapperTextfield
                style={{
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <Autocomplete
                  aria-required={true}
                  id="service-type-select"
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        borderBottom: "4px solid var(--darkwhite-color)",
                      }}
                      key={`product-quotation-${option._id}`}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          py: 2,
                          display: "flex",
                        }}
                      >
                        <Box sx={{ mr: 1 }}>
                          {!!option?.group_image?.product_display_image ===
                          false ? (
                            <ImageEmpty>
                              <InsertPhotoIcon
                                sx={{
                                  color: "rgba(0, 0, 0, 0.54)",
                                  cursor: "pointer",
                                }}
                              />
                            </ImageEmpty>
                          ) : (
                            <img
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                objectPosition: "center",
                                borderRadius: "16px",
                                marginRight: "8px",
                              }}
                              src={
                                option?.group_image?.product_display_image
                                  ? option?.group_image?.product_display_image.replace(
                                      ".com",
                                      ".com/300x300",
                                    )
                                  : ""
                              }
                              alt={option?.group_image?.product_display_image}
                            />
                          )}
                        </Box>

                        <Box
                          sx={{
                            width: "100%",
                            maxWidth: "calc(100% - 88px)",
                          }}
                        >
                          <TextOption>{option?.product?.item_name}</TextOption>

                          <TextOption color="grey">
                            {option?.product?.item_code}
                          </TextOption>

                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <img
                              style={{
                                width: "16px",
                                height: "16px",
                                objectFit: "cover",
                                objectPosition: "center",
                                borderRadius: "50%",
                              }}
                              src={
                                color_data.find(
                                  (detail) => detail._id === option?.color._id,
                                )?.icon_img || ""
                              }
                              alt={option?.group_image?.product_display_image}
                            />

                            <TextOption color="grey" sx={{ ml: 1, mb: 0 }}>
                              {getLocale() === "th"
                                ? option?.color?.color_th
                                : option?.color?.color_en}
                            </TextOption>
                          </Box>

                          <TextOption color="grey">
                            {option?.size?.quantity === "size"
                              ? `${option?.size?.width} ${
                                  getLocale() === "th"
                                    ? option?.size?.unit_width?.unit_th
                                    : option?.size?.unit_width?.unit_en
                                } x ${option?.size?.height} ${
                                  getLocale() === "th"
                                    ? option?.size?.unit_height?.unit_th
                                    : option?.size?.unit_height?.unit_en
                                } x ${option?.size?.thickness} ${
                                  getLocale() === "th"
                                    ? option?.size?.unit_thickness?.unit_th
                                    : option?.size?.unit_thickness?.unit_en
                                }`
                              : option?.size?.quantity === "capacity"
                                ? `${option?.size?.capacity_size} ${
                                    getLocale() === "th"
                                      ? option?.size?.unit_capacity?.unit_th
                                      : option?.size?.unit_capacity?.unit_en
                                  }`
                                : getLocale() === "th"
                                  ? "สินค้าสั่งทำพิเศษ"
                                  : "Made by order"}
                          </TextOption>

                          <TextOption color="grey">
                            {`${convertPrice(
                              option?.group_price?.is_start_price === true
                                ? option?.group_price?.start_price
                                : option?.group_price.special_price > 0 &&
                                    option?.group_price.special_price !==
                                      null &&
                                    option?.group_price.special_price !==
                                      undefined
                                  ? option?.group_price.special_price
                                  : option?.group_price?.price,
                            )}/${
                              getLocale() === "th"
                                ? option?.group_price?.unit_price?.unit_th
                                : option?.group_price?.unit_price?.unit_en
                            }`}
                          </TextOption>
                        </Box>
                      </Box>
                    </li>
                  )}
                  options={dataProductList}
                  value={selectedProduct?.product_choice_id}
                  onChange={(e, newValue) => {
                    if (newValue === null) {
                      setSelectedProduct({
                        product_choice_id: null,
                        service_type: null,
                        other_code: "",
                        other_text: "",
                        other_unit: "",
                        volume: 0,
                        price: 0,
                        discount: 0,
                        total: 0,
                        description: "",
                      });
                    } else {
                      setSelectedProduct((prev) => ({
                        ...prev,
                        product_choice_id: newValue,
                        price: newValue.group_price?.is_start_price
                          ? newValue.group_price?.start_price
                          : newValue.group_price?.special_price > 0 &&
                              newValue.group_price?.special_price !== null &&
                              newValue.group_price?.special_price !== undefined
                            ? newValue.group_price?.special_price
                            : newValue.group_price?.price,
                        volume: +prev.volume !== 0 ? prev.volume : 1,
                        total:
                          (newValue.group_price?.is_start_price
                            ? newValue.group_price?.start_price
                            : newValue.group_price?.special_price > 0 &&
                                newValue.group_price?.special_price !== null &&
                                newValue.group_price?.special_price !==
                                  undefined
                              ? newValue.group_price?.special_price
                              : newValue.group_price?.price) *
                            +prev.volume -
                          +prev.discount,
                      }));
                    }
                  }}
                  getOptionLabel={(option) => {
                    return (
                      option?.product?.item_name +
                      " - " +
                      option?.product?.item_code +
                      (option?.name !== "" ? ` - (` + option?.name + `)` : ``)
                    );
                  }}
                  filterOptions={filterOptions}
                  sx={{
                    my: 2,
                    width: "100%",
                    background: "#fff",
                    ".MuiOutlinedInput-root": {
                      paddingLeft: "16px",
                    },
                    ".MuiOutlinedInput-input": {
                      textAlign: "left",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="TextField-without-border-radius"
                      {...params}
                      placeholder="เพิ่มสินค้า"
                      error={selectedProduct?.product_choice_id === null}
                    />
                  )}
                />
              </WrapperTextfield>

              <Button
                variant="text"
                // size="small"
                onClick={() => {
                  setIsEditProduct(false);
                  setSelectedProduct((prev) => ({
                    ...prev,
                    product_choice_id: productData.product_choice_id,
                    price: productData.price,
                    volume:
                      prev.volume !== 0 ? prev.volume : productData.volume,
                    total:
                      (prev.volume !== 0 ? prev.volume : productData.volume) *
                      +productData.price,
                  }));
                }}
                sx={{
                  px: 3,
                  py: 1,
                }}
                startIcon={<NavigateBeforeIcon />}
              >
                Undo
              </Button>
            </WrapperHeader>
          ) : (
            <ProductDetail>
              <Box sx={{ mr: 2 }}>
                {!!selectedProduct?.product_choice_id?.group_image
                  ?.product_display_image === false ? (
                  <ImageEmpty>
                    <InsertPhotoIcon
                      sx={{
                        color: "rgba(0, 0, 0, 0.54)",
                        cursor: "pointer",
                      }}
                    />
                  </ImageEmpty>
                ) : (
                  <img
                    style={{
                      width: "96px",
                      height: "96px",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "16px",
                    }}
                    src={
                      selectedProduct?.product_choice_id?.group_image
                        ?.product_display_image
                        ? selectedProduct?.product_choice_id?.group_image?.product_display_image.replace(
                            ".com",
                            ".com/300x300",
                          )
                        : ""
                    }
                    alt={
                      selectedProduct?.product_choice_id?.group_image
                        ?.product_display_image
                    }
                  />
                )}
              </Box>

              <WrapperProduct>
                <TextItem width="calc(100% - 30px)">
                  {selectedProduct?.product_choice_id?.product?.item_name}
                </TextItem>

                <IconButton
                  aria-label="edit"
                  onClick={() => {
                    setIsEditProduct(true);
                  }}
                  sx={{
                    width: "30px",
                    p: "6px",
                  }}
                >
                  <EditIcon
                    sx={{
                      color: "var(--secondary-color)",
                      width: "16px",
                      height: "18px",
                    }}
                  />
                </IconButton>

                <TextItem color="grey">
                  {selectedProduct?.product_choice_id?.product?.item_code}
                </TextItem>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <img
                    style={{
                      width: "16px",
                      height: "16px",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "50%",
                    }}
                    src={
                      color_data.find(
                        (detail) =>
                          detail._id ===
                          selectedProduct?.product_choice_id?.color._id,
                      )?.icon_img || ""
                    }
                    alt={
                      selectedProduct?.product_choice_id?.group_image
                        ?.product_display_image
                    }
                  />

                  <TextItem color="grey" sx={{ ml: 1, mb: 0 }}>
                    {getLocale() === "th"
                      ? selectedProduct?.product_choice_id?.color?.color_th
                      : selectedProduct?.product_choice_id?.color?.color_en}
                  </TextItem>
                </Box>

                <TextItem color="grey">
                  {selectedProduct?.product_choice_id?.size?.quantity === "size"
                    ? `${selectedProduct?.product_choice_id?.size?.width} ${
                        getLocale() === "th"
                          ? selectedProduct?.product_choice_id?.size?.unit_width
                              ?.unit_th
                          : selectedProduct?.product_choice_id?.size?.unit_width
                              ?.unit_en
                      } x ${selectedProduct?.product_choice_id?.size?.height} ${
                        getLocale() === "th"
                          ? selectedProduct?.product_choice_id?.size
                              ?.unit_height?.unit_th
                          : selectedProduct?.product_choice_id?.size
                              ?.unit_height?.unit_en
                      } x ${
                        selectedProduct?.product_choice_id?.size?.thickness
                      } ${
                        getLocale() === "th"
                          ? selectedProduct?.product_choice_id?.size
                              ?.unit_thickness?.unit_th
                          : selectedProduct?.product_choice_id?.size
                              ?.unit_thickness?.unit_en
                      }`
                    : selectedProduct?.product_choice_id?.size?.quantity ===
                        "capacity"
                      ? `${
                          selectedProduct?.product_choice_id?.size
                            ?.capacity_size
                        } ${
                          getLocale() === "th"
                            ? selectedProduct?.product_choice_id?.size
                                ?.unit_capacity?.unit_th
                            : selectedProduct?.product_choice_id?.size
                                ?.unit_capacity?.unit_en
                        }`
                      : getLocale() === "th"
                        ? "สินค้าสั่งทำพิเศษ"
                        : "Made by order"}
                </TextItem>
              </WrapperProduct>
            </ProductDetail>
          )}
        </Header>

        <DetailSection>
          <DetailGroup>
            <TextLabel groupItem>ราคาสินค้า</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedProduct?.price}
              />
            </WrapperTextfield>

            <TextUnit>
              {selectedProduct?.product_choice_id !== null
                ? getLocale() === "th"
                  ? `บาท / ${selectedProduct?.product_choice_id?.group_price?.unit_price?.unit_th}`
                  : `Baht / ${selectedProduct?.product_choice_id?.group_price?.unit_price?.unit_en}`
                : getLocale() === "th"
                  ? `บาท / หน่วย`
                  : `Baht / unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>จำนวนสินค้า</TextLabel>

            <NumberGroup>
              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                disabled={selectedProduct?.volume < 1}
                onClick={() => {
                  setSelectedProduct((prev) => ({
                    ...prev,
                    volume: +prev.volume - 1,
                    total:
                      +selectedProduct.price * (+prev.volume - 1) -
                      +selectedProduct.discount,
                  }));
                }}
              >
                <RemoveIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>

              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  mx: 2,
                }}
                value={selectedProduct?.volume}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedProduct((prev) => ({
                      ...prev,
                      volume: +e.target.value,
                      total:
                        +selectedProduct.price * +e.target.value -
                        +selectedProduct.discount,
                    }));
                }}
                error={selectedProduct?.volume <= 0}
              />

              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                onClick={() => {
                  setSelectedProduct((prev) => ({
                    ...prev,
                    volume: +prev.volume + 1,
                    total:
                      +selectedProduct.price * (+prev.volume + 1) -
                      +selectedProduct.discount,
                  }));
                }}
              >
                <AddIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>
            </NumberGroup>

            <TextUnit>
              {selectedProduct?.service_type !== null
                ? getLocale() === "th"
                  ? `${selectedProduct?.service_type?.service_unit?.unit_th}`
                  : `${selectedProduct?.service_type?.service_unit?.unit_en}`
                : getLocale() === "th"
                  ? `หน่วย`
                  : `unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>ส่วนลด</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedProduct?.discount}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedProduct((prev) => ({
                      ...prev,
                      discount: e.target.value,
                      total:
                        +selectedProduct.price * +selectedProduct.volume -
                        +e.target.value,
                    }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedProduct((prev) => ({
                      ...prev,
                      discount: parseFloat(e.target.value) || 0,
                      total:
                        +selectedProduct.price * +selectedProduct.volume -
                        +e.target.value,
                    }));
                }}
              />
            </WrapperTextfield>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>รวมเงิน</TextLabel>

            <TextLabel totalPrice>
              {convertPrice(selectedProduct?.total)}
            </TextLabel>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>
        </DetailSection>
      </Content>

      <ButtonGroup justifyContent={"center"} alignItems={"center"}>
        <Button
          variant="contained"
          size="large"
          disabled={
            // selectedProduct?.product_choice_id?._id === productData?.product_choice_id?._id ||
            selectedProduct?.product_choice_id === null ||
            selectedProduct?.volume === 0
          }
          onClick={() => submitEdit()}
          sx={{
            width: "100%",
            maxWidth: 350,
            borderRadius: 4,
            py: 1.5,
          }}
        >
          {`Confirm`}
        </Button>

        <Button
          variant="contained"
          size="large"
          disabled={isRemoveDisabled}
          onClick={() => onRemoveElement()}
          sx={{
            width: "100%",
            maxWidth: 350,
            borderRadius: 4,
            py: 1.5,
            mt: 2,
            // boxShadow: "none",
            "&.MuiButton-contained": {
              backgroundColor: "#F7CECB",
              color: "var(--primary-color)",
            },
          }}
        >
          {`Delete`}
        </Button>
      </ButtonGroup>
    </>
  );
};

export default EditProduct;
